module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER ONE")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("M"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ARRYING")])]), _vm._v(" a man she didn’t love was surprisingly easy, Jasmine Kouri thought as she handed her empty champagne flute to a passing waiter. Why had she wasted so much time struggling to be alone? She should have done this a year ago.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Her engagement party was in full force. All of Qusay’s high society—everyone who’d once scorned her—was now milling beneath the white pavilion on the edge of the Mediterranean Sea, sipping Cristal in solid gold flutes as they toasted her engagement to the second richest man in Qusay.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Her fiancé had spared no expense. Jasmine’s fifteen-carat diamond ring scattered prisms and rainbows of refracted sunlight every time she moved her left hand. It was also very heavy, and the pale green chiffon dress he’d chosen for her in Paris felt hot as her skirts swirled in the desert wind. Across the wide grassy vista, the turrets of his sprawling Italianate mansion flew red flags emblazoned with his personal crest.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Then again, Umar Hajjar never spared any expense—on anything. Everything he owned, from his world-class "), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("racehorses to his homes around the world, proclaimed his money and prestige. He’d pursued Jasmine for a year in New York, and yesterday, she’d suddenly accepted his proposal. This party was Umar’s first step in making the people of Qusay forget her old scandal. He would shape Jasmine into his perfect bride, the same as he trained a promising colt into a winner: at any cost.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("But that wasn’t why Jasmine’s heart was pounding as she looked anxiously through the crowds in the pavilion. She didn’t care about money. She was after something far more precious.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jewel-laden socialites pressed forward to congratulate her, including some whose vicious gossip had ruined her when she was young and defenseless. But it would be bad manners to remember that now, so Jasmine just thanked them and smiled until her cheeks hurt.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Then she caught her breath as she saw the people she’d been waiting for.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Her family.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The last time she’d seen them, Jasmine had been a scared sixteen-year-old girl, packed off into poverty and exile by her harsh, heartbroken father and quietly weeping mother. Now because of this marriage, no one would ever be able hurt Jasmine—or her family—ever again.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("With a joyful cry, she held her arms wide, and her grown-up sisters ran to embrace her.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m proud of you, my daughter,” her father said gruffly, patting her on the shoulder. “At last you’ve done well.”")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Oh, my precious child.” Her mother hugged her tearfully, kissing her cheek. “It’s too long you’ve been away!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Both her parents had grown older. Her proud father was stooped, her mother gray. The sisters Jasmine remembered as skinny children were now plump matrons with husbands and children of their own. As her family embraced her, the wind blew around Jasmine’s ladylike dress, swirling around them all in waves of sea-foam chiffon.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("It was all worth it")]), _vm._v(", she thought in a rush of emotion. To be with her family again, to be back at home and have a place in the world, she would have given up a hundred careers in New York. She would have married Umar a thousand times.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I missed you all so much,” Jasmine whispered. But all too soon, she was forced to pull away from her family to greet other guests. Moments later, she felt Umar’s hand on her arm.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He smiled down at her. “Happy, darling?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yes,” she replied, wiping away the streaks of her earlier tears. Umar hated to see her mussed. “But some of the guests are growing impatient for dinner. Who is this special guest of yours and why is he so late?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You’ll see,” he replied, leaning down to kiss her cheek. Tall and thin and in his late forties, Umar Hajjar was the type of man who wore a designer suit to his stables. His face was pale and wrinkle-free with the careful application of sunscreen; his dark gray hair was slicked back with gel. He tilted his head. “Listen.”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("Frowning, she listened, then gradually heard a sound like thunder. She looked up, but as usual in the desert island kingdom, there were no clouds, just clear sky ")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("blending into sea in endless shades of blue. “What is that?”")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“It’s our guest.” Umar’s smile widened. “The king.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She sucked in her breath.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“The…king?” Sudden fear pinched her heart. “What king?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He laughed. “There is only one king, darling.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As if in slow motion, she looked back across the wide grass.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Three men on horseback had just come through the massive wrought-iron front gate. The Hajjar security guards were bowing low, their noses almost to the ground, as the leader of the horsemen rode past, followed by two men in black robes.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("They all had rifles and hard, glowering faces, but the leader was far taller and more broad-shouldered than the others. A ceremonial jeweled dagger at his hip proclaimed his status while the hard look in his blue eyes betrayed his ruthlessness. Beneath the hot Qusani sun, his robes were stark white against his deeply tanned skin as he leapt gracefully down from his black stallion.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Shaking in sudden panic, Jasmine looked at him, praying she was wrong. It couldn’t be him. Couldn’t!")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But when she looked at his handsome, brutal face, she could not deny his identity. For thirteen years, she’d seen his face in her dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Kareef Al’Ramiz, the barbarian prince of the desert.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The party guests recognized him with a low gasp that echoed her own.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Kareef.")]), _vm._v(" The man who’d seduced and deserted her to shame and exile. The man who’d caused the loneliness ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("and grief of half her life. The man who’d made her pay so dearly for the crime of loving him.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("And in a few days, Kareef Al’Ramiz would be crowned king of all Qusay.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Fierce hatred flashed through her, hatred so pure it nearly caused her to stagger. She clutched at Umar’s arm. “What is he doing here?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His thin lips curved in a smile. “The king is my friend. Are you impressed? It’s part of my plan. Come.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He pulled her across the grass to greet the royal arrival. She tried to resist, but Umar kept dragging her forward in his thin, sinewy grip. The colors of white tent and green grass and blue sea seemed to blend and melt around her. Trying to catch her breath, to regain control, she twisted her engagement ring tightly around her finger. The enormous diamond felt hard and cold against her skin.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Sire!” Hajjar called jovially across the lawn. “You do me great honor!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“This had better be important, Umar,” the other man growled. “Only for you would I return to the city in the middle of a ride.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("At the sound of Kareef’s voice—the deep, low timbre that had once sounded like music to her—the swirls of color started to spin faster. She started to fear she might faint at her own party. How would Umar react to that?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Marry me, Jasmine")]), _vm._v(". Kareef’s long-ago whisper echoed in her mind. He’d stroked her cheek, looking down at her with the deep hunger of desire. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Marry me.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("No! She couldn’t face Kareef after all these years. Not now. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Not ever!")])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("Her heart pounded furiously in her chest. “I have to ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("go,” she croaked, pulling frantically away from Umar’s grasp. “Excuse me—”")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Startled by her strength, Umar abruptly let go. Knocked off balance, she stumbled forward and fell across the grass in an explosion of pale green chiffon.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She heard a low exclamation. Suddenly hands were on her, lifting her to her feet.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She felt the electricity of a rough touch, so masculine and strong, so different from Umar’s cool, slender hands. She looked up.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Kareef’s handsome, implacable face was silhouetted against the sun as he lifted her to her feet. His ruthless eyes were full of shadow. Blinding light cast a halo around his black hair against the unrelenting blue sky.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His hand was still wrapped over hers as their eyes locked. His pupils dilated.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Jasmine,” he breathed, his fingers tightening on hers.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She couldn’t answer. Couldn’t even breathe. She dimly heard the cry of the seagulls soaring over the nearby Mediterranean, heard the buzz of insects. She was barely aware of the two hundred highborn guests behind them, watching from the pavilion.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Time had stopped. There was only the two of them. She saw him. She felt his touch on her skin. Exactly as she’d dreamed every night for the last thirteen years, in dark unwilling dreams she’d had alone in her New York penthouse.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Umar stepped between them.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Sire,” the older man said, beaming. “Allow me to present Jasmine Kouri. My bride.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  })]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("Kareef stared down at her beautiful face in shock.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He’d never thought he would see Jasmine Kouri again. Seeing her so unexpectedly—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("touching")]), _vm._v(" her—caused a blast of ice and fire to surge through his body, from his hair to his fingertips.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Against his will, his eyes devoured every detail of her face. Her long black eyelashes trembling against her creamy skin. The pink tip of her tongue darting out to lick the center of her full, red lips.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jasmine’s dark hair, once long and stick-straight, now was thickly layered past her shoulders, cascading over a flowy, diaphanous dress that seemed straight out of a 1930s Hollywood movie. The gown skimmed her full breasts and hips, tightly belted at her slim waist. Her graceful, slender arms could be seen through long sheer sleeves.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She was almost entirely covered from head to toe, showing bare skin only at the collarbone and hands, but the effect was devastating. She looked glamorous. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Untouchable.")]), _vm._v(" He wanted to grab her shoulders, to touch and taste and feel her all over and know she was real. Just the mere contact of his fingers against hers burned his skin.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Then he realized what Umar Hajjar had said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jasmine—Hajjar’s bride?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As if he’d been struck by a blow, Kareef abruptly released her. He glanced down at his fingers and was almost bewildered to find them whole. After the electricity he’d felt touching her hand, he’d half expected to find his fingers burned beyond recognition.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("With a deep breath, he slowly looked up at her. “You—are married?”")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Jasmine’s dark eyes met his, stabbing into his soul as deeply as a blade. Licking her lips nervously, she didn’t answer.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Not yet,” Umar purred beside her. “But we will be. Immediately following the Qais Cup.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Kareef continued to look at Jasmine, but she didn’t speak. Not one word.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Once, she used to chatter away in his company—she’d cajoled away his bad moods, making him laugh in spite of himself. He’d found her easy conversation relaxing. Charming. Perhaps because it was so natural—so unguarded and real. She’d been shy at first, a bookish girl more comfortable with reading newspapers and studying charts than speaking to the son of a sheikh. But once he’d coaxed her out of her shell, she’d happily told him every thought in her head.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("They’d both been so young then. So innocent.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Fire burned through him now as he looked at her. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jasmine.")]), _vm._v(" Her name was like a spell and he could barely stop himself from breathing it aloud. He had to force his face to remain expressionless, his body taut and implacable as if ready for battle.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To attack what? To defend what?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m so pleased you could attend our party at such late notice,” Umar continued, placing his hands on Jasmine’s shoulders. “We await your permission to serve dinner, my king.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Kareef found himself staring at Umar’s possessive hands on her shoulders. He had the sudden urge to knock them away—to start a brawl with the man who had once saved his life!")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("But this wasn’t just any woman. It was Jasmine. The girl he’d once asked to be his wife.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Sire?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yes. Dinner.” Still clenching his jaw, Kareef motioned to his two bodyguards to attend to the horses. He glanced toward the white pavilion and all the eager waiting faces. Several of the bolder guests were already inching closer to him, trying to catch his eye, hoping to join the conversation. After so many years of solitude in the northern desert of Qais, Kareef was not known for his sociability. But somehow being inaccessible and cold had just made him more desirable to the elite Qusanis of Shafar. Everyone in this godforsaken city seemed desperate for the barbarian king’s attention, his favor, his body or his soul.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He wasn’t even crowned yet, but according to Qusani tradition they already called him king—and treated him almost like a god. The people of Qusay had seen what he’d done for the desert people of Qais, and wanted that same prosperity for themselves. So they worshipped him.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Kareef hated it. He’d never wanted to come back here. But a few weeks ago, shortly after the death of the old king in a plane crash, his cousin, the crown prince, had abruptly removed himself from the line of succession. Xavian—no, Zafir, Kareef corrected himself, so strange to suddenly call the man he had thought his cousin by a new name!—had learned he had not a single drop of Al’Ramiz blood in his veins, and he’d abdicated the throne. He’d left to jointly rule the nation of Haydar with his wife, Queen Layla.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("Zafir’s decision had been correct and honorable. Kareef would have approved his actions completely, ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("except for one thing: it had forced him to accept the throne in his place.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("And now—he would see Jasmine married to another man before his very eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Or would he? Legally, morally, could he allow it?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He cursed beneath his breath.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You honor us, sire.” Umar Hajjar bowed. “If I may ask another favor…”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Kareef growled a reply.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Will you do my future bride the honor of escorting her into the pavilion?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He wanted Kareef to touch her? To take her by the hand? Just looking at Jasmine was torture. She’d once been an enchanting girl with big dark eyes and a willowy figure. Now she’d grown into her curves. She’d become a mature woman. Her expression held mystery and hidden sorrows. A man could look into that face for years and never discover all her secrets.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jasmine Kouri was, quite simply, the most beautiful woman Kareef had ever seen in his life.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("And she continued to look at him silently with her dark gaze, her eyes accusing him of everything her lips did not. Reminding him of everything he’d nearly killed himself to forget.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Kareef closed his eyes, briefly blocking her from his vision. He forced his body to be calm, his breathing to become steady and even. He discarded emotion from his body, brushing it from his soul like dirt off his skin. After so many years of practice, he knew exactly what to do.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Then he opened his eyes and discovered he’d learned nothing.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Looking at Jasmine, years of repressed desire dissolved his will into dust. Heat flashed through him, whipping through his skin like a sandstorm flaying the flesh off his living bones.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He wanted her. He always had. As he’d never wanted any woman.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Sire?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Unwillingly, Kareef held out his arm, a mark of the highest respect for another man’s bride. When he spoke, his voice was utterly cold and controlled.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Shall we go in to the banquet, Miss Kouri?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She hesitated, then placed her hand on his arm. He could feel the heat of her light touch through the fabric of his sleeve. She tilted her head back to look up at him. Her beautiful brown eyes glittered. “You honor me, my king.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("No one but Kareef could hear the bitter irony beneath her words.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The party guests stepped back with deep, reverent bows as he led Jasmine up on the dais, Umar following behind them. Once they were on the dais, Kareef dropped her hand. He picked up a gold flute from the table.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Instantly, the two hundred guests went silent, waiting breathlessly for their new king to speak.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I wish to thank my honored host and friend, Umar Hajjar, for his gracious invitation.” He gave his old friend a nod. In response, Umar bowed, elegant in his designer suit. “And I wish to welcome his future bride, Jasmine Kouri, back to her homeland. You grace our shores with your beauty, Miss Kouri.” He held up the flute, looking at the guests with hard eyes as he intoned forcefully, “To the happy couple.”")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“To the happy couple,” the guests repeated in awed unison.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jasmine said nothing. But as they sat down, he could feel the glow of her hatred pushing against him in waves of palpable energy.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dinner was served, a meal of limitless, endless courses of lamb and fish, of spiced rice and olives and baked aubergines stuffed with meat. Each dish was more elaborate than the last. And through it all, Kareef was aware of Jasmine sitting next to him. She barely ate, even when encouraged by her fiancé. She just gripped her fork and knife tightly. Like weapons.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You should eat, my dear,” Umar Hajjar chided her from the other side. “It would be unattractive for you to grow too thin.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Unattractive? "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jasmine?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Kareef frowned. Thin or fat, naked or dressed in a burlap sack, any man would want her. He clenched his hands into fists upon the table. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("He")]), _vm._v(" wanted her. Right now. On this table.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("No")]), _vm._v(", he told himself fiercely. He wouldn’t touch her. He’d sworn thirteen years ago to leave Jasmine in peace. And she was now engaged to another man—his friend.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Turning to Umar Hajjar, Kareef forced himself to speak normally. “I did not know you were friends.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“We met in New York last year.” Umar gave her arm a friendly little squeeze. “After my poor wife died, I asked Jasmine many times to marry me. She finally accepted yesterday.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yesterday? And you plan to wed in a few days?” he said evenly. “A swift engagement. There are no…impediments?”")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Jasmine looked at Kareef sharply, with an intake of breath. He did not meet her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Umar shrugged carelessly. “Any wedding can be arranged quickly, if a man does not care about the cost.” He glanced down at Jasmine teasingly. “Beautiful women can be fickle. I’m not going to give this one a chance to change her mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jasmine looked down at her full plate, her cheeks bright red. She ran tracks through her rice with her fork.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I would have married her immediately, in New York,” Umar continued, “but Jasmine wished to be reconciled with her family. After my horse wins the Qais Cup, we will move to America for half the year to pursue my next goal—the Triple Crown. And of course I will take over Jasmine’s business in New York. Her only job will be as mother to my four sons. But her connections in America will be useful to me as I…”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He paused when one of his servants bent to whisper in his ear. Abruptly, Umar rose to his feet. “Excuse me. I must take a phone call. With your permission, sire…?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Kareef gave him a single nod. After he left, as all the guests on the lower floor buzzed loudly with their own discussions, he lowered his head to speak in a low voice to Jasmine alone.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Does he know?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Her whole body became strangely still. “Don’t even think about it,” she ground out. “It doesn’t count. It meant nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You know you cannot marry him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Don’t be ridiculous.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Jasmine.”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("“No! I don’t care if you’re king, I won’t let you ruin ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("my life—again!” Her eyes flashed at him. “I won’t let you ruin my family’s hopes with this wedding—”")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Your family needs the wedding?” he interrupted.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Clenching her jaw, she shook her head. “I won’t let them be crushed by my old scandal again, not when everyone’s still buzzing about my sister!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Which sister?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Staring at him, she exhaled. “You haven’t heard? I thought everyone in Qusay knew.” She gave a sudden humorless laugh. “My youngest sister Nima was at boarding school in Calista. She had a one-night stand with some sailor whose name she can’t even remember. Now she’s pregnant. Pregnant at sixteen.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pregnant")]), _vm._v(" floated between them like poisoned air.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Ripping his gaze away, Kareef glanced at her large family, now seated at a lower table. At Umar Hajjar crossing the grass near the tent. At all the guests watching the king surreptitiously beneath the white pavilion. Then he looked back at Jasmine, and it all faded away. He couldn’t see anything but the beauty of her face—the endless darkness of her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Nima’s staying in New York now, living in my apartment, trying to wrap her head around the thought that she will soon be a mother.” She blinked back tears. “My baby sister. When she showed up on my doorstep two days ago, I suddenly realized how much time I’d lost. Thirteen years without my family.” Her voice cracked. “No money can replace that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“So you got engaged to Umar Hajjar,” he said quietly. He narrowed his eyes. “Do you love him?”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("With a sigh, she rubbed her neck. “When my father ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("sent me away thirteen years ago,” she whispered, “he said not to bother coming home again. Not until I was a respectable married woman.”")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Kareef set his jaw, furious as he glared at her. “So that’s why you got engaged?” he bit out. “To please your father?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She looked up at him, hatred suddenly blazing in her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What do you care? You washed your hands of me long ago. In a few days I’ll be married and out of your life forever.” She lifted her chin, and her eyes glittered. “So leave me alone. Go get yourself crowned. Sire.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In all the years he’d known Jasmine, he’d never heard that bitter tone from her lips. But could he blame her? What she’d gone through would make any woman’s soul grow brittle. Her young spirit had been so happy and bright, but he’d crushed that long ago. His hands tightened as he leaned forward over the table.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“But Jasmine,” he said in a low voice, “you have to know that I—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Forgive me,” Umar Hajjar interrupted, his voice high and strained. They turned almost guiltily to find him standing behind them. “My children’s nanny was on the phone. There is an emergency. I must go.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Oh no!” Jasmine rose to her feet anxiously. “I will come with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Umar held up his hand. “I must go alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What? Why? Please, Umar,” she begged. “Let me come with you. You might need my help!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“No,” he said harshly. His eyes fell upon Kareef. “My king, I ask you to take Jasmine under your protection.”")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“No! Absolutely not!” she cried, too loudly. Guests turned to look.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Jasmine,” Umar cautioned in a low, hard voice, “do not create a scene.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She swallowed. “I won’t,” she choked out softly. Her dark eyes glimmered, pleading with him as they turned away from the crowd. “Just don’t leave me with the king.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Why?” her fiancé demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She licked her lips, glancing at Kareef beneath trembling lashes. “Though he is king…he is also still a man.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Don’t be foolish, Jasmine. He’s the king!” Umar said. “His word is unbreakable. His honor is respected across the world. He—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“No, she is right,” Kareef interrupted. He looked down at Jasmine with glittering eyes. “Though I am king,” he said in a low, dangerous voice, “I am also still a man.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Her long, black eyelashes swept across her pale cheeks as she visibly trembled beneath his gaze.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“And I would trust you with my life,” Umar said stoutly. “Please. You must take her, sire.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Kareef slowly turned to his old friend. Bring Jasmine back to the royal palace? Beneath the same roof? The gleaming palace already felt like a prison with its thick walls, when Kareef hungered for the wide freedom of the desert. He couldn’t imagine being trapped in that gilded cage with the additional torture of Jasmine’s company—under his protection as he waited for her to marry another man!")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“No,” he said coldly. “She cannot stay at the palace. It’s impossible.”")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("But even as Jasmine exhaled in relief, Umar pressed his lips together. “She cannot stay unchaperoned here until we are married. It would be improper. I have my children to consider.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Send her home to her family.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“It will be far more useful if she stays at the palace, my king.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Ah, so this was about status. Kareef’s lip twisted with scorn.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“For Jasmine’s sake,” the other man added in a low voice. “Your attention will go far to negate her old scandal. People will forget the whispers beneath the weight of your honor.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Staring at him, Kareef frowned in sudden indecision.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Umar lowered his head. “My king, if I have ever done anything worthy of your esteem, I beg you this one favor. Place my bride formally under your protection until the day of the Qais Cup, when I will return to marry her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("If")]), _vm._v(" he’d ever done anything worthy of Kareef’s esteem?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He’d helped Kareef bring prosperity to the desert. Made him the godfather of two of his four young sons. And most of all—he’d found Kareef in the desert, half-mad and dying of thirst thirteen years ago. He’d brought him home, brought him back to health. He’d saved Kareef’s life.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Perhaps…” Kareef said grudgingly, and Umar pounced.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("“Your mother is at the palace, is she not, sire? She ")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("will make a fine chaperone, if you are concerned about propriety.”")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“No,” Jasmine whimpered softly. “I won’t do it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Umar ignored her. He kept staring at Kareef with hope—almost desperation.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("If the bride had been any other woman, Kareef would have immediately agreed. But not "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("this")]), _vm._v(" woman. He cursed beneath his breath. Damn it, didn’t the man see the risk?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("No, of course he did not. Umar had no idea Kareef was the one who’d taken her virginity and caused her accident in the desert thirteen years ago. No one knew Kareef was the man who’d been her lover, her partner in the scandal. Jasmine had made sure of that.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She still hated him. He saw it in her eyes. But he had no choice.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Slowly, Kareef rose to his feet. His voice was loud, ringing with authority beneath the white pavilion.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“As of this moment, and until the day of her marriage, Jasmine Kouri is under my protection.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Another buzz rose across the crowd. They stared at Jasmine with awe. Even her old father cracked an amazed smile.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("If only he knew the truth, Kareef thought grimly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Nodding in relief, Umar turned to go.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Wait,” Jasmine cried, grabbing her fiancé’s slender wrist. “I still don’t know what’s happened! Are your children sick? Is it the baby?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“The children are well. I cannot say more.” The older man’s eyes were narrow and tight. “I will call you if I can. Otherwise—I will see you at the race. On our wedding day.”")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("And he was gone. Kareef and Jasmine sat alone on the dais, with two hundred pairs of eyes upon them.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Keeping his face impassive, Kareef threw down the linen napkin across his empty plate and glanced at Jasmine’s untouched dinner and stricken, forlorn face. “Are you finished?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yes,” she whispered miserably, as if she were trying not to cry.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He held out his hand. “Then let us go.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She focused her eyes on him. “Forget it. I’ve been under my own "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("protection")]), _vm._v(" for years. I do not need or want yours.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He continued to hold out his hand. “And yet you have it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I will go stay at my family’s house.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Your betrothed wishes otherwise.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“He is not the boss of me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Is he not?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She tossed her head. “I will stay at a hotel.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She was trying her best to be insolent, making it clear she did not respect him. He should have been insulted, but as he watched the tip of her pink tongue dart out to lick her lips, he couldn’t look away from the lush, sensual mouth he’d kissed long ago. It seemed like only yesterday. His lips tingled, remembering hers.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("With a deep breath, he forced himself to look up. “You will find no available hotel room, anywhere on this island. All the world has come for my coronation.” He tightened his jaw. “But that is not the point.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“And that is?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I gave my word to Hajjar,” he ground out. “And I keep my promises.”")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Do you?” Her eyes glinted at him sardonically. “A new skill?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Anger flashed through him. But he held it back, dousing it with ice. He deserved the jibe. He would accept it from Jasmine as he would from no other person alive.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He would still prevail.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Are you afraid to be near me?” he quietly taunted.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Afraid of you?” Her voice shimmered with hatred like moonlight on water. “Why should I be?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He held out his hand. “Then come.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Narrowing her eyes at him in fury, she pushed her hand into his. She never could resist a dare. But the same instant he knew he’d won, he felt the electric shock of her touch. And realized he was the one who should be afraid.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He, Kareef Al’Ramiz, the prince of the desert, soon to be absolute ruler of the kingdom of Qusay, should be afraid of what he’d do when left alone with this woman he craved. This woman he could not have. His friend’s betrothed. Because Jasmine wasn’t simply a woman to him.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She was the only woman.")])])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page26"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19328941","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tamedthebarbarianking_ch01.vue
// module id = 75
// module chunks = 0